export default __webpack_public_path__ + "static/media/Abhishek.4896c621.jpeg";